// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

import type { ChartType } from '@/lib/analytics/charts/chart.type';

export const likesHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.youtube.likes_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.youtube.likes_history_name',
        paid: 'paid_data',
        organic: 'organic_data',
        avg: 'chart.youtube.likes_history_avg'
    },
    id: 'likes_history',
    color: {
        value: 'blue',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.youtube.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.youtube.likes_history_tooltip',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
